// src/hooks/useCountryPrefix.js
import { useLocation } from "react-router-dom";

export const useCountryPrefix = () => {
    const location = useLocation();

    const getCountryPrefix = () => {
        let match = location.pathname.split("/").filter(Boolean); // removes empty strings
        if (match.length > 0) {
            return match[0]; // first part of path (eg, ae, au, etc.)
        }
        return "eg"; // fallback default
    };

    return getCountryPrefix();
};
